import { createFileRoute } from "@tanstack/react-router";
import { JaziaShell } from "@/components/jazia/JaziaApp";
import { LoanApplyPage } from "@/components/loans/LoanApplyPage";
import { requireAuth } from "@/lib/require-auth";

export const Route = createFileRoute("/loans_/apply/$step")({
  beforeLoad: () => {
    requireAuth();
  },
  component: function LoanApplyRoute() {
    const { step } = Route.useParams();
    return (
      <JaziaShell page="loans">
        <LoanApplyPage step={step} />
      </JaziaShell>
    );
  },
});
